import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { SharedModule } from '../../shared.module';
import { ApiService } from '../../../services/api.service';
import {
  CountryISO,
  SearchCountryField,
  NgxIntlTelInputModule,
} from 'ngx-intl-tel-input';
import { SuccessModalComponent } from '../success-modal/success-modal.component';
@Component({
  selector: 'app-contact-us-form',
  imports: [
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    NgxIntlTelInputModule,
    SuccessModalComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  standalone: true,
  templateUrl: './contact-us-form.component.html',
  styleUrl: './contact-us-form.component.css',
})
export class ContactUsFormComponent {
  contactForm: FormGroup;
  isSubmitted = false;

  CountryISO = CountryISO;
  SearchCountryField = SearchCountryField;
  showSuccessModal = false;

  constructor(private fb: FormBuilder, private apiService: ApiService) {
    this.contactForm = this.fb.group({
      senderFirstName: [
        '',
        [Validators.required, Validators.pattern(/^[A-Za-z]+(?: [A-Za-z]+)*$/)],
      ],
      senderLastName: [
        '',
        [Validators.required, Validators.pattern(/^[A-Za-z]+(?: [A-Za-z]+)*$/)],
      ],
      senderEmail: [
        '',
        [
          Validators.required,
          Validators.email,
          Validators.pattern(
            '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$'
          ),
        ],
      ],
      countryCode: ['IT', Validators.required],
      mobilePhone: ['', Validators.required],
      emailBody: ['', [Validators.required, Validators.minLength(10)]],
    });
  }

  getContactControl(controlName: string): FormControl | null {
    return this.contactForm.get(controlName) as FormControl;
  }

  onSubmit() {
    this.isSubmitted = true;
    this.contactForm.markAllAsTouched();

    if (this.contactForm.invalid) {
      return;
    }

    const formValue = this.contactForm.value;
    const payload = {
      senderFirstName: formValue.senderFirstName,
      senderLastName: formValue.senderLastName,
      senderEmail: formValue.senderEmail,
      emailBody: formValue.emailBody,
      mobilePhone: formValue.mobilePhone?.nationalNumber,
      countryCode: formValue.mobilePhone?.countryCode?.toUpperCase(),
    };

    this.apiService.contactUs(payload).subscribe({
      next: (response) => {
        this.contactForm.reset();
        this.isSubmitted = false;
        this.showSuccessModal = true;
      },
      error: (err) => {
        console.error('API Error:', err);
      },
    });
  }
}
